<template>
  <div class="headerTop">
    <img class="logo" src="../../../assets/img/logo/logo.png" alt />
    <span class="copyright"></span>
    <!-- <img class="copyright" src="../../../assets/img/logo/TAL.png" alt /> -->
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.headerTop {
  min-width: 1200px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 60px;
  .logo {
    width: 313px;
    height: 34px;
  }
  .copyright {
    height: 40px;
    width: 266px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/videoShare/components/header.vue